import { ui } from './ui'
import { header } from './header'
import { footer } from './footer'
import { feedPage } from './feedPage'
import { explorePage } from './explorePage'
import { myToysPage } from './myToysPage'
import { cartPage } from './cartPage'
import { paymentsPage } from './paymentsPage'
import { sellToyPage } from './sellToyPage'
import { withdrawPage } from './withdrawPage'
import { postPage } from './postPage'
import { gamesPage } from './gamesPage'
import { settingsPage } from './settingsPage'
import { errorPages } from './errorPages'
import { authPage } from './authPage'
import { toyPage } from './toyPage'
import { sorting } from './sorting'
import { goldPlans } from './goldPlans'
import { errors } from './errors'
import { buttons } from './buttons'
import { toys } from './toys'
import { publicProfile } from './publicProfile'
import { privacyPage } from './privacyPage'
import { termsOfUsePage } from './termsOfUsePage'
import { faqPage } from './faqPage'
import { createToy } from './createToy'

import { enType } from '../en'
import { collectionsPage } from './collectionsPage'
import { artistsPage } from './artistsPage'
import { drops } from './drops'
import { referralAwards } from './referralAwards'
import { paymentHistoryPage } from './paymentHistoryPage'
import { profilePage } from './profilePage'
import { collectionPage } from './collectionPage'
import { news } from './news'
import { quiz } from './quiz'
import { block } from './block'
import { report } from './report'

const ru: Record<enType, string> = {
    ...quiz,
    ...ui,
    ...header,
    ...footer,
    ...feedPage,
    ...explorePage,
    ...myToysPage,
    ...cartPage,
    ...collectionPage,
    ...paymentsPage,
    ...sellToyPage,
    ...withdrawPage,
    ...postPage,
    ...gamesPage,
    ...settingsPage,
    ...errorPages,
    ...authPage,
    ...toyPage,
    ...sorting,
    ...goldPlans,
    ...profilePage,
    ...errors,
    ...buttons,
    ...toys,
    ...publicProfile,
    ...privacyPage,
    ...termsOfUsePage,
    ...faqPage,
    ...createToy,
    ...collectionsPage,
    ...news,
    ...artistsPage,
    ...paymentHistoryPage,
    ...drops,
    ...referralAwards,
    ...block,
    ...report,
}

export default ru
